<template>
  <v-layout class="filter-row" @click="editFilter" row wrap>
    <v-flex class="mt-2" xs4>
      <div class="filter-number mr-4">{{ position }}</div>
      <div class="ml-4">
        <v-icon class="k-orange-linear-text ml-4 mr-3 filter-icon">fas fa-code-branch</v-icon>
        <span class="filter-name text">{{ filter.name }}</span>
      </div>
    </v-flex>
    <v-flex xs6 class=" d-flex align-center justify-center">
      <drop-menu class="mr-3" v-for="(channel) in filteredChannels" :key="`channel-${channel.id}`"
        btn-type="icon"
        :btn-icon="channel.icon"
        :disabled="!canEditWhatsappWorkflow && channel.name === 'whatsapp'"
        :btn-class="{ 'k-orange-linear-text': filter[`send_${channel.name}`] }">
        <template v-if="!isPaymentType" slot="top">
          <div class="channel-badge">{{ filter[daysOffG[channel.name]] || 0 }}</div>
        </template>
        <div v-if="canCreate" @click.stop="toggleChannelStatus(channel.name)" class="content-menu">
          {{ statusChannelAction(channel.name) }}</div>
        <div @click.stop="editTemplate(channel.name)" class="content-menu">
          Ajustes de canal
        </div>
        <div v-if="canCreate && showTest(channel)" @click.stop="testTemplate(channel)" class="content-menu">Probar</div>
        <div v-if="!isPaymentType" @click.stop="openTriggerModal(channel.name)" class="content-menu">
          Triggers
        </div>
        <div class="pl-1" v-if="channel.name === 'bot' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('bot_calls_queue')" v-model="filter.bot_calls_queue" :value="1" :hide-details="true" class="custom-checkbox"
            label="Prioridad Alta" />
        </div>
        <div class="pl-1" v-if="channel.name === 'bot' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('bot_calls_queue')" v-model="filter.bot_calls_queue" :value="2" :hide-details="true" class="custom-checkbox"
            label="Prioridad Media" />
        </div>
        <div class="pl-1" v-if="channel.name === 'bot' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('bot_calls_queue')" v-model="filter.bot_calls_queue" :value="3" :hide-details="true" class="custom-checkbox"
            label="Prioridad Baja" />
        </div>
        <div class="pl-1" v-if="channel.name === 'ivr' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('ivr_calls_queue')" v-model="filter.ivr_calls_queue" :value="1" :hide-details="true" class="custom-checkbox"
            label="Prioridad Alta" />
        </div>
        <div class="pl-1" v-if="channel.name === 'ivr' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('ivr_calls_queue')" v-model="filter.ivr_calls_queue" :value="2" :hide-details="true" class="custom-checkbox"
            label="Prioridad Media" />
        </div>
        <div class="pl-1" v-if="channel.name === 'ivr' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('ivr_calls_queue')" v-model="filter.ivr_calls_queue" :value="3" :hide-details="true" class="custom-checkbox"
            label="Prioridad Baja" />
        </div>
        <div class="pl-1" v-if="channel.name === 'sms' && canCreate" @click.stop>
          <v-checkbox @change="changeConfig('cheap_sms')" v-model="filter.cheap_sms" :hide-details="true" class="custom-checkbox"
            label="Solo reportar" />
        </div>
      </drop-menu>
    </v-flex>
    <v-flex xs2 class="d-flex align-center justify-end mt-3">
      <tooltip icon-path="filters_icon.svg" customIcon>
        <template slot="content">
          <v-layout v-if="getFilters.length === 0" class="no-filters-badge">
            Sin Filtros
          </v-layout>
          <v-layout wrap row v-for="(stageFilter, sfIndex) in getFilters" :key="`sFilter-${sfIndex}`">
            <v-flex xs12 class="d-flex justify-center">
              <div class="conector-badge px-3 mt-1">
                {{ connectors[stageFilter.operator] }}
              </div>
            </v-flex>
            <v-flex xs12 class="d-flex justify-center mt-1" v-for="(item, itemIndex) in stageFilter.items"
              :key="`sFilter-${itemIndex}`">
              <div class="counter-tooltip pa-1">
                <span>{{ getFilterTitle(item.field) }}</span>
                <span>{{ getOperatorName(item.operator) }}</span>
                <span>{{ getFilterValue(item.field, item.value) }}</span>
              </div>
            </v-flex>
          </v-layout>
        </template>
      </tooltip>
      <tooltip :class="{'ml-4':filter.type_id === 2,'pl-3':filter.type_id === 2}" v-if="filter.type_id" :icon-path="getTypeIcon" customIcon>
        <template v-if="filter.type_id === 2" slot="customBtn">
          <div class="ml-3 fixed-hour">{{ filter.fixed_hour | formatHour }}</div>
        </template>
        <template slot="content">
          <v-layout wrap row class="tooltip-type">
            <v-flex xs12 class="type-header my-0">
              <span class="type-title">
                Tipo de gestión:
              </span>
              <span class="mt-2">
                {{ types[filter.type_id].label }}
              </span>
            </v-flex>
            <v-flex xs12 class="type-text mt-2" v-if="filter.type_id === 2">
              <v-icon size="14">fas fa-clock fa-sm</v-icon>
              <span class="ml-2">{{ filter.fixed_hour | formatHour }}</span>
            </v-flex>
          </v-layout>
        </template>
      </tooltip>
      <v-icon v-if="canCreate" @click.stop="toggleFilterStatus" class="status-btn mx-4 pl-3 pr-2" :color="statusColor" small>
        fas fa-power-off
      </v-icon>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';
import EventBus from '@/event-bus';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import permissionsMixin from '@/mixins/permissions';
import DropMenu from '@/components/global/DropMenu';
import Tooltip from '@/components/global/Tooltip.vue';
import comparsionOperatorsMixin from '@/mixins/comparisonOperators';

export default {
  components: {
    DropMenu,
    Tooltip,
  },
  mixins: [
    filtersMixin,
    channelsMixin,
    permissionsMixin,
    comparsionOperatorsMixin,
  ],
  inject: {
    // Release de colly por canal (sms, email, whatsapp) que provee la página del flujo.
    collyRelease: { default: () => ({}) },
  },
  props: {
    filter: {
      type: Object,
      required: true,
      defualt: {},
    },
    position: {
      type: Number,
      default: 0,
      required: true,
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    formatHour(hour) {
      return moment(hour, 'hh:mm:ss').format('hh:mm')
    },
  },
  data() {
    return {
      connectors: {
        'and': 'Conector Y',
        'or': 'Conector O',
      },
      daysOffG: {
        'human': 'days_off_g1',
        'bot': 'days_off_g2',
        'ivr': 'days_off_g2',
        'sms': 'days_off_g3',
        'email': 'days_off_g4',
        'whatsapp': 'days_off_g5',
      },
      types: {
        1: {
          label: 'Regular',
          icon: 'Gestion_icon.svg',
        },
        2: {
          label: 'Dual hora fija',
          icon: 'Gestion_dual_hora_fija_icon.svg',
        },
        3: {
          label: 'Dual hora IA',
          icon: 'Gestion_AI_icon.svg',
        },
      },
      toggleValues: {
        'Activo': 'Inactivo',
        'Inactivo': 'Activo',
      },
    };
  },
  computed: {
    canCreate() {
      return this.checkPermissions([
        'create_workflow_notifications',
        'edit_workflow_notifications',
      ]);
    },
    isPaymentType() {
      return 'broken_promises' in this.filter;
    },
    isFilterActive() {
      return this.filter.status === 'Activo' || this.filter.status === 1;
    },
    statusColor() {
      if (this.isFilterActive) {
        return 'green';
      }
      return 'red';
    },
    filteredChannels() {
      const allChannels = ['email', 'sms', 'bot', 'ivr', 'human'];
      const channelsToExclude = ['bot'];

      if (this.isWhatsappOutboundActive) {
        allChannels.push('whatsapp');
      }

      if (this.isPaymentType) {
        return this.channels.filter(item =>
          allChannels.includes(item.name) && !channelsToExclude.includes(item.name)
        );
      }

      return this.channels.filter(item => allChannels.includes(item.name));
    },
    getFilters() {
      const filters = this.filter.filters;

      if (typeof filters === 'string') {
        return JSON.parse(filters).items || [];
      }
      return filters.items || [];
    },
    getTypeIcon() {
      return this.types[this.filter.type_id].icon;
    },
    canEditWhatsappWorkflow() {
      return this.checkPermissions([
        'edit_whatsapp_workflow',
      ]);
    },
  },
  methods: {
    changeConfig(field) {
      const payload = {
        filterId: this.filter.id,
        data: {
          [field]: this.filter[field],
        },
        isPaymentType: this.isPaymentType,
      };

      this.$emit('change-filter-config', payload);
    },
    editTemplate(channel) {
      this.$emit('edit-template', { filter: this.filter, channel });
    },
    openTriggerModal(channelName) {
      this.$emit('open-trigger-modal', { filter: this.filter, channelName });
    },
    statusChannelAction(channel) {
      const status = this.filter[`send_${channel}`];
      if (!status) {
        return 'Activar';
      }
      return 'Desactivar';
    },
    editFilter() {
      this.$emit('edit', this.filter);
    },
    toggleChannelStatus(channel) {
      let template;
      const idTemplateChannels = ['ivr', 'bot'];

      if (this.isWhatsappOutboundActive) {
        idTemplateChannels.push('whatsapp');
      }
      if ((!this.isPaymentType || channel === 'ivr') && _.includes(idTemplateChannels, channel)) {
        template = this.filter[`${channel}_template_id`];
      } else {
        template = this.filter.template[channel];
      }

      const newStatus = this.filter[`send_${channel}`] ^ 1;

      const hasCollyTemplate = !!this.filter[`colly_${channel}_template_id`];
      if (newStatus === 1 && (template === '' || template === null) && channel !== 'human' && !hasCollyTemplate) {
        EventBus.$emit('modal', `El canal ${channel} no tiene texto`);
        return;
      }

      this.$emit('change-channel-status', { [`send_${channel}`]: newStatus });
    },
    openTemplateDialog(channel) {
      this.$emit('edit-template', channel);
    },
    showTest(channel) {
      return !this.collyRelease[channel.name];
    },
    testTemplate(channel) {
      const { id: channelId } = channel;

      let templateId = (this.filter.template || {}).id;
      if (channelId === 3) {
        templateId = this.filter.ivr_template_id;
      } else if (channelId === 4) {
        templateId = this.filter.bot_template_id;
      } else if (channelId === 7) {
        templateId = this.filter.whatsapp_template_id;
      }

      this.$emit('test-template', { channelId, templateId });
    },
    toggleFilterStatus() {
      let newStatus;
      if (!this.isPaymentType) {
        newStatus = this.toggleValues[this.filter.status]
      } else {
        newStatus = this.filter.status ^ 1;
      }
      const payload = { status: newStatus };
      this.$emit('change-filter-status', payload);
    },
  },
}
</script>

<style scoped>
.filter-number {
  width: 25px;
  height: 25px;
  background-color: #FF7C64;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  margin-left: 0;
  padding: 0;
  border-radius: 3px 0px 4px 0px;
}

.filter-name {
  font: normal normal bold 16px/21px Roboto;
  color: #000000;
}

.no-filters-badge {
  display: flex;
  justify-content: center;
  font-weight: bold;
  text-align: center;
}

.conector-badge {
  max-width: max-content;
  background: #DFDFDF 0% 0% no-repeat padding-box;
  border-radius: 100px;
  color: 2E2E44;
  display: flex;
  justify-content: center;
  font: normal normal medium 10px/13px Roboto;
}

.counter-tooltip {
  display: flex;
  justify-content: space-between;
  font: normal normal medium 14px/19px Roboto;
  border: 1px solid #E0E0E0;
  border-radius: 3px;
  min-width: 348px;
}

.tooltip-type {
  max-width: 124px;
  min-height: fit-content;
  background-color: #FFFFFF !important;
  color: #2E2E44;
  display: flex;
  justify-content: start;
}

.type-header span {
  display: block;
}

.type-header .type-title {
  font-weight: bold;
}

.tooltip-type .type-text {
  align-content: center;
}

.status-btn {
  cursor: pointer;
}

.content-menu {
  padding: 7px;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.content-menu:hover {
  background: #E0E0E0 0% 0% no-repeat padding-box;
}

.channel-badge {
  position: relative;
  width: 20px;
  height: 20px;
  background-color: #ebebeb;
  border: 2px solid #FFFFFF;
  border-radius: 50%;
  text-align: center;
  top: 23px;
  left: 28px;
  z-index: 8;
  font-size: 12px;
  color: black;
  font-weight: bold;
}

.filter-row:hover {
  background-color: #DCDEDF;
}

.text {
  display: block;
  white-space: normal;
  word-wrap: break-word;
  overflow: visible;
}

.filter-icon {
  margin-top: -16px;
  font-size: 36px;
}

.custom-checkbox {
  width: 210px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowDetail/FilterItem.vue